var path = '/registration/form/form-field-text.html';
var html = "<input type=\"text\" class=\"form-control\" name=\"{{$ctrl.field.key}}\" id=\"field_{{$ctrl.field.key}}\"\n   ng-model=\"$ctrl.model[$ctrl.field.key]\"\n   ng-required=\"$ctrl.field.required\">\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;